module.exports = __webpack_public_path__ + "img/caes.4377d828.jpg";